import React, { useState, useEffect } from "react";
import { Container, ListGroup, Button, Spinner, Alert, Card, Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css"; // Ensure this file has correct CSS
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const [hoveredId, setHoveredId] = useState(null);

  const handleLogin = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  useEffect(() => {
    const fetchTests = async () => {
      try {
        const response = await fetch(
          `https://testresult.omegacareerinstitute.com/admin/welcome/showtestlist/${localStorage.getItem("rollno")}`
        );
        const responseData = await response.json();

        const testsArray = responseData.data || [];

        if (!Array.isArray(testsArray)) {
          throw new Error("Invalid data format: Expected an array");
        }

        const sortedTests = testsArray.sort((a, b) => new Date(b.entrydate) - new Date(a.entrydate));
        setTests(sortedTests);
      } catch (error) {
        console.error("Failed to fetch tests:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTests();
  }, []);

  return (
    <Container>
      {/* Top Bar */}
      <div
     
        className="header p-3 d-flex justify-content-between align-items-center rounded"
      >
        <div className="user-details">
          <h5 className="mb-1">Name: {localStorage.getItem("name")}</h5>
          <h6 className="mb-1">Father Name: {localStorage.getItem("father")}</h6>
          <h6 className="mb-0">Roll No.: {localStorage.getItem("rollno")}</h6>
        </div>
        <Button variant="light" className="fw-bold" onClick={handleLogin}>
          Logout
        </Button>
      </div>

      {/* Top Image */}
      <img
        src="https://testresult.omegacareerinstitute.com/What-is-Test-Plan-1.png"
        alt="Top Banner"
        className="img-fluid mb-4"
        style={{ borderRadius: "10px" }}
      />

      {/* Menu Button */}
      <div className="d-flex justify-content-end mb-3">
        {/* <Button
          variant="dark"
          onClick={() => setMenuOpen(!menuOpen)}
          style={{ borderRadius: "20px", fontWeight: "bold" }}
        >
          {menuOpen ? "Close Menu" : "Menu"}
        </Button> */}
      </div>

      {/* Collapsible Card Menu */}
      {/* {menuOpen && (
        <Card className="p-3 shadow-sm mb-3" style={{ borderRadius: "10px" }}>
          <h5 className="mb-3 text-center">Quick Access</h5>
          <div className="d-flex flex-wrap justify-content-around">
            <Badge pill bg="primary" className="p-3 m-1" style={{ cursor: "pointer" }}>
              All Test Report
            </Badge>
            <Badge pill bg="success" className="p-3 m-1" style={{ cursor: "pointer" }}>
              Progress Report
            </Badge>
            <Badge pill bg="warning" className="p-3 m-1 text-dark" style={{ cursor: "pointer" }}>
              Attendance
            </Badge>
            <Badge pill bg="danger" className="p-3 m-1" style={{ cursor: "pointer" }}>
              NEET Qualify Status
            </Badge>
          </div>
        </Card>
      )} */}

      {/* Skeleton Loading (Stakeholder Style) */}
      {loading ? (
        <ListGroup>
          {[1, 2, 3, 4].map((index) => (
            <ListGroup.Item
              key={index}
              className="d-flex justify-content-between align-items-start mb-2 shadow-sm position-relative skeleton"
              style={{ borderRadius: "10px", padding: "15px", height: "80px" }}
            >
              <div className="skeleton-text" style={{ width: "80%" }}></div>
              <div className="skeleton-button"></div>
            </ListGroup.Item>
          ))}
        </ListGroup>
      ) : error ? (
        <Alert variant="danger">Error: {error}</Alert>
      ) : (
       <ListGroup>
  {tests.map((test) => (
    <Link
      to={test.status === "Active" ? `/testlist/${test.testid}` : "#"}
      key={test.testid}
      style={{ textDecoration: "none", color: "inherit", pointerEvents: test.status === "Active" ? "auto" : "none" }}
    >
      <ListGroup.Item
        className="d-flex justify-content-between align-items-start mb-2 shadow-sm position-relative"
        style={{
          borderRadius: "10px",
          padding: "15px",
          transition: "opacity 0.3s ease-in-out",
          cursor: test.status === "Active" ? "pointer" : "not-allowed",
          opacity: hoveredId === test.testid ? 0.7 : 1,
        }}
        onMouseEnter={() => setHoveredId(test.testid)}
        onMouseLeave={() => setHoveredId(null)}
      >
       <div style={{ flex: 1 }}>
  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
    {/* Row 1 */}
    <li
      style={{
        display: "grid",
        gridTemplateColumns: "100px 1fr",
        alignItems: "center",
        marginBottom: "6px",
      }}
    >
      <span
        style={{
          fontWeight: 600,
          color: "#555",
         
        }}
      >
        TS Name:
      </span>

      <span style={{  fontWeight: 500 }}>
     {test.testname}
      </span>
    </li>

    {/* Row 2 */}
    <li
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  }}
>
  {/* LEFT SIDE: Status */}
 <span
    style={{
      color: test.status === "Active" ? "green" : "red",
      fontWeight: 600,
     
    }}
  >
   <span style={{color:"#000"}}>Status/</span>{test.status}
  </span>

  {/* RIGHT SIDE: View Link */}
  <Button
    to={`/testlist/${test.testid}`}
    style={{
      fontSize: "12px",
      fontWeight: "600",
     
      textDecoration: "none",
    }}
  >
    View
  </Button>
</li>

  </ul>
</div>

       
      </ListGroup.Item>
    </Link>
  ))}
</ListGroup>

      )}
    </Container>
  );
};

export default Dashboard;
